(() => {
  function initialise(root) {
    if (root.dataset.plockInitialised) return;
    root.dataset.plockInitialised = 'true';
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-plock-image]');
      if (thumb) {
        const image = root.querySelector('.gg-plock-main-image');
        image.removeAttribute('srcset'); image.src = thumb.dataset.plockImage; image.alt = thumb.dataset.plockAlt;
        root.querySelectorAll('[data-plock-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }
      const button = event.target.closest('[data-plock-quantity]');
      if (button) {
        const input = button.closest('[data-plock-unit]')?.querySelector('[data-plock-unit-quantity]') || button.closest('form').querySelector('input[name="quantity"]');
        const minimum = input.min === '' ? 1 : Number(input.min), increment = Number(input.step) || 1;
        let value = Math.max(minimum, (Number(input.value) || minimum) + Number(button.dataset.plockQuantity) * increment);
        if (input.max) value = Math.min(Number(input.max), value);
        input.value = value; input.dispatchEvent(new Event('change', {bubbles:true}));
      }
    });
    const automaticPallet = root.querySelector('[data-plock-auto-pallet]');
    if (automaticPallet) {
      const form = automaticPallet.querySelector('form');
      const quantity = form.querySelector('input[name="quantity"]');
      const submit = form.querySelector('button[type="submit"]');
      const status = automaticPallet.querySelector('[data-plock-auto-status]');
      const palletSize = Number(automaticPallet.dataset.palletSize);
      const directLimit = Number(automaticPallet.dataset.directLimit);
      const initiallyDisabled = submit.disabled;
      let switching = false;
      const updateQuantity = () => {
        const count = Number(quantity.value);
        const blocked = Number.isInteger(count) && count > directLimit && count !== palletSize;
        status.hidden = !blocked;
        status.textContent = blocked ? automaticPallet.dataset.directWarning : '';
        submit.disabled = initiallyDisabled || switching || blocked || !quantity.checkValidity();
      };
      const switchPallet = () => {
        if (Number(quantity.value) !== palletSize || switching) return false;
        switching = true;
        updateQuantity();
        const url = new URL(location.href);
        url.searchParams.set('variant', automaticPallet.dataset.palletVariant);
        url.searchParams.delete('quantity');
        location.assign(url.href);
        return true;
      };
      quantity.addEventListener('input', updateQuantity);
      quantity.addEventListener('change', () => { if (!switchPallet()) updateQuantity(); });
      form.addEventListener('submit', event => {
        if (switching || Number(quantity.value) === palletSize) {
          event.preventDefault();
          switchPallet();
          return;
        }
        updateQuantity();
        if (submit.disabled) event.preventDefault();
      });
      updateQuantity();
    }
    const multi = root.querySelector('[data-plock-multi]');
    if (multi) {
      const rows = [...multi.querySelectorAll('[data-plock-unit]')];
      const submit = multi.querySelector('[data-plock-multi-submit]');
      const status = multi.querySelector('[data-plock-multi-status]');
      const total = multi.querySelector('[data-plock-multi-total]');
      const money = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style: 'currency', currency: multi.dataset.currency || 'EUR'});
      let busy = false;
      const palletSize = Number(multi.dataset.palletSize);
      const shippingTotal = multi.querySelector('[data-plock-shipping-total]');
      const packCount = multi.querySelector('[data-plock-pack-count]');
      const composition = multi.querySelector('[data-plock-composition]');
      const selection = () => {
        const count = Number(packCount.value);
        if (!Number.isInteger(count) || count < 1 || count > Number(packCount.max)) return [];
        const pallets = Math.floor(count / palletSize), packs = count % palletSize;
        return rows.map(row => ({row, quantity: row.dataset.unitKind === 'pallet' ? pallets : packs})).filter(item => item.quantity > 0);
      };
      const update = () => {
        const chosen = selection();
        const count = Number(packCount.value);
        composition.hidden = count < palletSize || !Number.isInteger(count);
        composition.textContent = composition.hidden ? '' : composition.dataset.palletLabel + (count % palletSize ? ' + ' + (count % palletSize) + ' ' + composition.dataset.extraLabel : '');
        const unavailable = chosen.some(item => item.row.dataset.available !== 'true');
        const valid = multi.checkValidity();
        total.textContent = money.format(chosen.reduce((sum, item) => sum + Number(item.row.dataset.price) * item.quantity, 0) / 100);
        const shippingGrams = chosen.filter(item => item.row.dataset.unitKind !== 'pallet').reduce((sum, item) => sum + Number(item.row.dataset.grams) * item.quantity, 0);
        const shippingCents = shippingGrams === 0 ? 0 : shippingGrams <= 12000 ? 1160 : shippingGrams <= 30000 ? 2321 : shippingGrams <= 45000 ? 3481 : shippingGrams <= 60000 ? 4641 : 5355;
        shippingTotal.textContent = money.format(shippingCents / 100);
        submit.disabled = busy || !valid || !chosen.length || unavailable;
        status.hidden = !unavailable;
        status.textContent = unavailable ? multi.dataset.previewMessage : '';
      };
      multi.addEventListener('input', update);
      multi.addEventListener('change', update);
      multi.addEventListener('submit', async event => {
        event.preventDefault();
        update();
        if (submit.disabled || !multi.reportValidity()) return;
        const items = selection().map(item => ({id: item.row.dataset.variantId, quantity: item.quantity}));
        busy = true;
        submit.disabled = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
            method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})
          });
          if (!response.ok) throw new Error('Cart request failed');
          location.assign(multi.dataset.cartUrl);
        } catch (error) {
          busy = false;
          update();
          status.hidden = false;
          status.textContent = multi.dataset.errorMessage;
        }
      });
      update();
    }
    const palletLink = root.querySelector('[data-plock-pallet-offer]');
    if (palletLink) {
      const updatePalletLink = () => {
        const quantity = root.querySelector('input[name="quantity"]');
        const amount = Math.max(1, Number(quantity?.value) || 1);
        const url = new URL(palletLink.dataset.inquiryUrl, location.origin);
        const lines = [
          'Produkt: ' + palletLink.dataset.productTitle,
          'Artikelnummer: ' + palletLink.dataset.productSku,
          'Variante: ' + palletLink.dataset.variantTitle,
          'Aktuelle Auswahl: ' + amount + ' Verkaufseinheit(en)',
          'Produktlink: ' + new URL(palletLink.dataset.productUrl, location.origin).href,
          'Anfrage: Bitte erstellen Sie ein Angebot für eine volle oder gemischte Plock-Palette inklusive Versand.'
        ];
        url.searchParams.set('gg_inquiry', lines.join('\n'));
        url.searchParams.set('gg_kind', 'plock-pallet');
        url.hash = 'partnerregistrierung';
        palletLink.href = url.href;
      };
      root.addEventListener('input', updatePalletLink);
      root.addEventListener('change', updatePalletLink);
      updatePalletLink();
    }
    const select = root.querySelector('[data-plock-variant]');
    if (select) select.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('variant', select.value); location.assign(url.href);
    });
  }
  function start() { document.querySelectorAll('[data-plock-product]').forEach(initialise); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();

